import { BaseThemeType, styled } from 'opensolar-ui'

interface ExpoNavLinkButtonProps {
  active?: boolean
}

export const ExpoNavLinkButton = styled('a', {
  name: 'ExpoNavLinkButton',
  shouldForwardProp: (prop) => prop !== 'active',
})<ExpoNavLinkButtonProps>((props: { active?: boolean; theme?: BaseThemeType }) => ({
  padding: '0 12px',
  cursor: 'pointer',
  position: 'relative',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  fontWeight: 500,
  fontFamily: props.theme?.typography.fontFamily,
  color: `${props.theme?.palette.grey[810]} !important`,
  backgroundColor: `${props.theme?.palette.neutralGrey[100]} !important`,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-20px',
    left: 0,
    right: 0,
    height: '3px',
    backgroundColor: props.active ? props.theme?.palette.primary.main : 'transparent',
  },
}))
